import React, { Component } from 'react';
import { SanitizedInnerHTML } from 'src/common';
import { IconLabel } from 'src/components/administration/IconLabel';

export default class InfoDetails extends Component {
    render() {
        return (
            <details
                className="alert alert-info"
                style={{ marginBottom: '10px', paddingTop: '5px', paddingBottom: '5px' }}>
                <summary style={{ cursor: 'pointer' }}>
                    <IconLabel icon="info-sign" text={this.props.summary} />
                </summary>
                <hr style={{ marginTop: '5px', marginBottom: '5px' }} />
                <SanitizedInnerHTML html={this.props.details} />
            </details>
        );
    }
}
